export const createWidgetCard = async (
  sendAndWaitWs,
  canvasId,
  title,
  widgets
) => {
  const request = { canvasId, title, widgets };
  const response = await sendAndWaitWs(
    "/ui/widgetCard/create",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const updateCanvasCards = async (sendAndWaitWs, canvasId, cards) => {
  const request = { canvasId, cards };
  const response = await sendAndWaitWs(
    "/ui/card/save",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const updateCardLayout = async (sendAndWaitWs, canvasId, cards) => {
  const request = { canvasId, cards };
  const response = await sendAndWaitWs(
    "/ui/card/layout/update",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const updateCardContent = async (
  sendAndWaitWs,
  cardId,
  widgets,
  setting
) => {
  const request = { cardId, widgets, setting };
  const response = await sendAndWaitWs(
    "/ui/card/update",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const deleteCard = async (sendAndWaitWs, canvasId, cardId) => {
  const request = { canvasId, cardId };
  const response = await sendAndWaitWs(
    "/ui/card/delete",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const copyCard = async (sendAndWaitWs, canvasId, cardId) => {
  const request = { canvasId, cardId };
  const response = await sendAndWaitWs(
    "/ui/card/copy",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listCanvas = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/ui/canvas/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getCanvasContent = async (sendAndWaitWs, canvasId) => {
  const request = { canvasId };
  const response = await sendAndWaitWs(
    "/ui/canvas/getContent",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const upsertCanvas = async (sendAndWaitWs, canvas) => {
  const request = {
    canvasId: canvas.id,
    name: canvas.name,
  };
  const response = await sendAndWaitWs(
    "/ui/canvas/save",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const deleteCanvas = async (sendAndWaitWs, canvasId, force) => {
  const request = {
    canvasId,
    force,
  };
  const response = await sendAndWaitWs(
    "/ui/canvas/delete",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const batchDeleteCard = async (sendAndWaitWs, canvasId, cardIds) => {
  const request = {
    canvasId,
    cardIds,
  };
  const response = await sendAndWaitWs(
    "/ui/card/batchDelete",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const reorderCanvas = async (sendAndWaitWs, newIndexes) => {
  const request = {
    newIndexes,
  };
  const response = await sendAndWaitWs(
    "/ui/canvas/reorder",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const moveCanvas = async (
  sendAndWaitWs,
  toCanvasId,
  cardId,
  fromCanvasId
) => {
  const request = { toCanvasId, cardId, fromCanvasId };
  const response = await sendAndWaitWs(
    "/ui/card/move",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const batchMoveCanvas = async (
  sendAndWaitWs,
  toCanvasId,
  cardIds,
  fromCanvasId
) => {
  const request = { toCanvasId, cardIds, fromCanvasId };
  const response = await sendAndWaitWs(
    "/ui/card/batchMove",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const createEntityTwinCard = async (
  sendAndWaitWs,
  canvasId,
  integration,
  entityId,
  entityName,
  entityType,
  twinTags,
  group,
  twinSig
) => {
  const request = {
    canvasId,
    integration,
    entityId,
    entityName,
    entityType,
    twinTags,
    group,
    twinSig,
  };
  const response = await sendAndWaitWs(
    "/ui/twinCard/create",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};

export const batchCreateEntityTwinCard = async (
  sendAndWaitWs,
  canvasId,
  integration,
  entityType,
  items
) => {
  const request = {
    canvasId,
    integration,
    entityType,
    items,
  };
  const response = await sendAndWaitWs(
    "/ui/twinCard/batchCreate",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const createAutomationCard = async (
  sendAndWaitWs,
  canvasId,
  automationId
) => {
  const request = { canvasId, automationId };
  const response = await sendAndWaitWs(
    "/ui/automationCard/create",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return result && result.success;
};
